<template>
  <b-container>
    <b-card
      title="Account basic"
      class="col-lg-8 offset-lg-2 col-xl-4 offset-xl-4"
    >
      <b-form @submit.prevent="update">
        <b-form-group label="Email" label-class="font-weight-bold">
          {{ user.email }}
        </b-form-group>
        <b-form-group label="Password" label-class="font-weight-bold">
          <router-link to="/accounts/password/" class="btn"
            >Change Your Password</router-link
          >
        </b-form-group>
        <hr />
        <b-form-group label="Name" label-class="font-weight-bold">
          <b-form-input
            type="text"
            v-model="user.name"
            :state="feedback.name ? !feedback.name : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.name"
            v-if="feedback.name"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Phone">
          <b-form-input
            type="tel"
            v-model="user.phone"
            :state="feedback.phone ? !feedback.phone : null"
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.phone"
            v-if="feedback.phone"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <hr />
        <b-form-group
          label="Username (URL)"
          description="The username must contain only letters, numbers, dot(.), at(@), underscore(_) and hyphen(-)."
        >
          <ul>
            <li>
              pixpills.com/<i>{{ user.username || "username" }}</i>
            </li>
          </ul>
          <b-form-input
            type="text"
            placeholder="username"
            v-model="user.username"
            :state="feedback.username ? !feedback.username : null"
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.username"
            v-if="feedback.username"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <hr />
        <b-form-group label="Date of birth" label-class="font-weight-bold">
          <b-form-input
            type="date"
            placeholder="YYYY-MM-DD"
            v-model="user.date_of_birth"
            :state="feedback.date_of_birth ? !feedback.date_of_birth : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.date_of_birth"
            v-if="feedback.date_of_birth"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Gender" label-class="font-weight-bold">
          <b-form-radio-group
            v-model="user.gender"
            :state="feedback.gender ? !feedback.gender : null"
            required
          >
            <b-form-radio value="Male">Male</b-form-radio>
            <b-form-radio value="Female">Female</b-form-radio>
            <b-form-radio value="Other">Other</b-form-radio>
          </b-form-radio-group>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.gender"
            :style="{ display: feedback.gender ? 'block' : null }"
            v-if="feedback.gender"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <div class="submit-button-group">
          <b-button type="submit" variant="primary">Update</b-button>
        </div>
      </b-form>
    </b-card>
    <b-card
      title="Account deletion"
      class="col-lg-8 offset-lg-2 col-xl-4 offset-xl-4"
    >
      <template v-if="user.is_premium">
        <p class="text-danger">
          유료 멤버십은 간략한 탈퇴 신청서 작성 후 이메일로 탈퇴 승인 안내를
          받을 수 있습니다.<br />
          Paid membership can be withdrawn approval by email after completing a
          brief withdrawal applicant form.
        </p>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSf7ceEKG_oUzUIrdQgX6La0AX7MKTr7gvRVoEvOwLtkGxhPCA/viewform"
          target="_blank"
          class="btn btn-white-red-hover"
          >Apply Deletion</a
        >
      </template>
      <template v-else>
        <p class="text-danger">
          멤버 탈퇴를 하시면 작성한 모든 자료가 삭제되며 더 이상 계정을 사용하실
          수 없습니다.<br />
          By deleting your account you remove your personal information from
          pixpills.<br />
          Your account cannot be restored.
        </p>
        <b-btn variant="white-red-hover" @click="showRemoveModal">Delete</b-btn>
      </template>
    </b-card>
    <b-modal size="" title="Delete Account" ref="remove">
      <p>
        멤버 탈퇴를 하시면 작성한 모든 자료가 삭제되며 더 이상 계정을 사용하실
        수 없습니다.
      </p>
      <p class="m-0">
        By deleting your account you remove your personal information from
        pixpills.<br />
        Your account cannot be restored.
      </p>
      <template slot="modal-footer">
        <b-btn variant="secondary" @click="closeRemoveModal">취소</b-btn>
        <b-btn variant="red-hover" @click="remove">탈퇴</b-btn>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from "vue";
import { User } from "../models";

export default Vue.component("account", {
  data() {
    return {
      user: new User(window.user),
      feedback: {}
    };
  },
  methods: {
    async update() {
      try {
        window.user = await this.user.save();
        this.feedback = {};
      } catch ({ response }) {
        if (response.status === 400) {
          this.feedback = response.data;
        }
      }
    },
    showRemoveModal() {
      this.$refs.remove.show();
    },
    async remove() {
      await this.user.delete();
      window.location = "/";
    },
    closeRemoveModal() {
      this.$refs.remove.hide();
    }
  }
});
</script>
